import db, { storage } from './firebase';
import { v4 as uuidv4 } from 'uuid';

export const createFranchiseEventsDocument = async (details) => {
    // get the reference to the Firestore document
    const uniqueId = uuidv4();
    const docRef = db.doc(`/Events/${uniqueId}`);

    //create user object
    details.uniqueId = uniqueId;
    details.eventPostedDateTime = new Date();

    // write to Cloud Firestore
    await docRef.set(details);
    const getBackEvent = db.doc(`/Events/${uniqueId}`);
    await getBackEvent.get().then(result => {
        console.info('result',result?.exists)
        if(result?.exists) {
            return true;
        } else {
            return false
        }
    });
}

export const getFranchiseEventsDocumentWithUserId = async (userId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Events').where("userId","==", userId).where("eventCategory","==", "Franchise Events").get()
    return snapshot.docs.map(doc => doc.data());
}

export const getFranchiseEventsDocumentWithUniqueId = async (uniqueId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Events').where("uniqueId", "==", uniqueId).where("eventCategory","==", "Franchise Events").get()
    return snapshot.docs.map(doc => doc.data());
}

export const getFranchiseEventsDetails = async (uniqueId) => {
    // get the reference to the Firestore document
    let event = null;
    let retailer = null;
    const eventSnapshot = await db.collection('Events').where("uniqueId", "==", uniqueId).where("eventCategory","==", "Franchise Events").get()
    eventSnapshot.docs.map(doc => {
        event = doc.data()
    });

    const employerSnapshot = await db.collection('Users').where("userId", "==", event.userId).get()
    employerSnapshot.docs.map(doc => {
        retailer = doc.data()
    });
    return {
        event: event,
        retailer: retailer
    }
}

export const getAllFranchiseEventsDocument = async () => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('Events').where("eventCategory","==", "Franchise Events").get()
    return snapshot.docs.map(doc => doc.data());
}

export const updateFranchiseEventsDocument = async (event) => {
    const docRef = db.doc(`/Events/${event.uniqueId}`);
    return docRef.update(event);
}

export const getAllApplicantCvs = async (employerId) => {
    // get the reference to the Firestore document
    const snapshot = await db.collection('AppliedEvents').where("employerId", "==", employerId).get()
    return snapshot.docs.map(doc => doc.data());
}



export const uploadFranchiseEventsImageInBase64 = (eventId, file, progress) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const filePath = `events/${eventId}/${"image-" + Date.now()}`;
        const fileRef = storage.ref().child(filePath);

        // upload task        
        const uploadTask = fileRef.putString(file, 'base64', {contentType:'image/jpeg'});
        uploadTask.on('state_changed', (snapshot) => progress(snapshot), (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}

export const uploadFranchiseDocument = (filePath, file) => {
    return new Promise((resolve, reject) => {
        // create file reference
        const fileRef = storage.ref().child(filePath);

        // upload task
        const uploadTask = fileRef.put(file);
        uploadTask.on('state_changed', null, (error) => reject(error), () => {
            resolve(uploadTask.snapshot.ref);
        });
    });
}